import { CheckCircle } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Container,
  List,
  ListDivider,
  ListItem,
  ListItemContent,
  Snackbar,
  Stack,
  Typography,
} from "@mui/joy";
import * as React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSelector } from "react-redux";
import HeaderBackButton from "../components/HeaderBackButton";
import { signOut } from "firebase/auth";
import { auth } from "../config/firebase";
import { useNavigate } from "react-router";

export default function Profile() {
  const navigate = useNavigate();
  const userInfos = useSelector((state) => state.useInfos);
  const { mobile, mobilecode } = userInfos;
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const str = userInfos.email;
  const firstTwoChars = str.slice(0, 2);

  const url = `${window.location.protocol}//${window.location.host}`;
  const encodedurl = btoa(url);

  const logOut = () => {
    signOut(auth)
      .then(() => {
        console.log("Signed out");
        navigate("/auth/login");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <HeaderBackButton title={"Profile"} />
      <Container maxWidth="sm">
        <Stack spacing={3}>
          <Box>
            <Stack spacing={1} justifyContent={"center"} alignItems={"center"}>
              <Avatar
                variant="outlined"
                color="neutral"
                sx={{ width: 70, height: 70 }}
              >
                <Typography fontSize={"x-large"} textTransform={"uppercase"}>
                  {firstTwoChars}
                </Typography>
              </Avatar>
              <Typography level="body-md">{userInfos.email}</Typography>
              <Button variant="outlined" color="neutral" onClick={logOut}>
                Sign out
              </Button>
            </Stack>
          </Box>

          <List variant="outlined" sx={{ minWidth: 240, borderRadius: "sm" }}>
            <ListItem>
              <ListItemContent>
                <Stack spacing={0}>
                  <Typography level="body-md">User ID</Typography>
                  <Typography level="body-sm" noWrap={true} width={"50%"}>
                    {userInfos.id}
                  </Typography>
                </Stack>
              </ListItemContent>
              <CopyToClipboard text={userInfos.id} onCopy={() => setOpen(true)}>
                <Button
                  variant="soft"
                  color="neutral"
                  sx={{ borderRadius: 10 }}
                >
                  Copy
                </Button>
              </CopyToClipboard>
            </ListItem>
            <ListDivider />

            {mobile === undefined || mobile === null || mobile === "" ? null : (
              <>
                <ListItem>
                  <ListItemContent>
                    <Stack spacing={0}>
                      <Typography level="body-md">Mobile</Typography>
                      <Typography level="body-sm" noWrap={true} width={"50%"}>
                        {`${mobilecode} ${mobile}`}
                      </Typography>
                    </Stack>
                  </ListItemContent>
                  <CopyToClipboard
                    text={`${mobilecode} ${mobile}`}
                    onCopy={() => setOpen(true)}
                  >
                    <Button
                      variant="soft"
                      color="neutral"
                      sx={{ borderRadius: 10 }}
                    >
                      Copy
                    </Button>
                  </CopyToClipboard>
                </ListItem>
                <ListDivider />
              </>
            )}

            <ListItem>
              <ListItemContent>
                <div>
                  <Stack spacing={1} direction={"row"} alignItems={"center"}>
                    <Typography level="body-md">KYC</Typography>
                    <Avatar size="xsm" variant="outlined" color="neutral">
                      <CheckCircle
                        fontSize="large"
                        color={userInfos.kyc_verified ? "success" : "disabled"}
                      />
                    </Avatar>
                  </Stack>
                  <Typography
                    level="body-sm"
                    color={userInfos.kyc_verified ? "success" : "warning"}
                  >
                    {userInfos.kyc_verified
                      ? "KYC verified"
                      : "KYC not verified"}
                  </Typography>
                </div>
              </ListItemContent>

              <Button
                disabled={userInfos.kyc_verified || userInfos.activated}
                variant="solid"
                color="primary"
                sx={{ borderRadius: 10 }}
                onClick={() => {
                  window.location.href = `https://imagekycupload.web.app/${encodedurl}/${userInfos.id}`;
                }}
              >
                Verify
              </Button>
            </ListItem>
          </List>
        </Stack>
      </Container>
      <Snackbar
        color="success"
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        onClose={handleClose}
      >
        Address copied
      </Snackbar>
    </>
  );
}
